import { ConnectDragSource } from "react-dnd"
import PinIcon from '@mui/icons-material/PushPinRounded'
import ArrowDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowUpIcon from '@mui/icons-material/ArrowDropUp'
import TuneIcon from '@mui/icons-material/Tune'
import DoubleArrowIcon from '../svgicons/DoubleArrowVerical'
import { Box } from '@mui/material'

type HsSectionBoxPropsType = {
    onAction?: (event: React.MouseEvent<HTMLDivElement>, ...rest: any[]) => void,
    order?: number,
    dragHandle?: ConnectDragSource,
    cursor?: string,
    hide?: boolean,
}
export const HsOpenSectionBox: React.FC<HsSectionBoxPropsType & { open?: boolean, toggleOpen?: () => void }> = ({ onAction, open }) =>
    <HsActionBox onAction={onAction}>
        {open
            ? <ArrowUpIcon />
            : <ArrowDownIcon />
        }
    </HsActionBox>
export const HsOptionsSectionBox: React.FC<HsSectionBoxPropsType> = ({ onAction, hide }) =>
    <HsActionBox onAction={onAction} hide={hide}><TuneIcon /></HsActionBox>
export const HsOrderSectionBox: React.FC<HsSectionBoxPropsType> = ({ onAction, order, dragHandle }) => {
    return (
        <Box ref={dragHandle} sx={{ position: 'relative' }}>
            <HsActionBox cursor='move'><DoubleArrowIcon /></HsActionBox>
        </Box>
    )
}
export const HsPinSectionBox: React.FC<HsSectionBoxPropsType & { pin?: boolean }> = ({ onAction, pin, hide }) =>
    <HsActionBox onAction={onAction} hide={hide} >
        <PinIcon sx={{ transform: pin ? 'rotate(45deg)' : undefined }} />
    </HsActionBox>

export const HsActionBox: React.FunctionComponent<React.PropsWithChildren<HsSectionBoxPropsType>> = ({ onAction, children, cursor, hide }) => {
    const handleClick = (ev: React.MouseEvent<HTMLDivElement>) => {
        ev.stopPropagation()
        ev.preventDefault()
        onAction && onAction(ev)
    }
    return (
        <Box sx={{ height: '24px', cursor: cursor ? cursor : 'pointer', visibility: hide ? 'hidden' : 'visible' }} onClick={handleClick}>
            {children}
        </Box>
    )
}